import React from 'react';
import {withTranslation} from "react-i18next";
import logo from "../img/wide-logo.png";

let termsFooter = ({t}) => {
	return <div id="footer-terms">
		<img src={logo} alt="Proximus" />
		<div id="footer-terms-text">
			<div>{`${t('footer.rights')} \u00A9${new Date().getFullYear()} Proximus`}</div>
			<div>
				<a href={t('footer.urls.termsAndConditions')} className="footerLink">
					{t('footer.termsAndConditions')}
				</a>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
				<a href={t('footer.urls.privacy')} className="footerLink">
					{t('footer.privacy')}
				</a>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
				<a href={t('footer.urls.cookies')} className="footerLink">
					{t('footer.cookies')}
				</a>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
				<a href="mailto:proximussurprise@proximus.com" className="footerLink">
					{t('footer.unsubscribe')}
				</a>
				<div>
					{t('footer.created')}
				</div>
				<div>
					{t('footer.address')}
				</div>
			</div>
		</div>
	</div>;
};

export default withTranslation() (termsFooter)